import { render } from "./DashboardItemWrapper.vue?vue&type=template&id=580837d5&scoped=true"
import script from "./DashboardItemWrapper.vue?vue&type=script&lang=js"
export * from "./DashboardItemWrapper.vue?vue&type=script&lang=js"

import "./DashboardItemWrapper.vue?vue&type=style&index=0&id=580837d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580837d5"]])

export default __exports__